// extracted by mini-css-extract-plugin
export var border = "_m-7";
export var brand = "_m-s";
export var button = "_m-k";
export var center = "_m-9";
export var centered = "_m-5";
export var closeButton = "_m-b";
export var disabledWrapper = "_m-l";
export var error = "_m-o";
export var extraLarge = "_m-4";
export var extraSmall = "_m-1";
export var fill = "_m-h";
export var footer = "_m-g";
export var footerAction = "_m-i";
export var footerButtons = "_m-j";
export var header = "_m-6";
export var headerWithClose = "_m-c";
export var icon = "_m-n";
export var info = "_m-r";
export var inline = "_m-8";
export var large = "_m-3";
export var main = "_m-d";
export var modal = "_m-0";
export var neutral = "_m-t";
export var noPadding = "_m-f";
export var none = "_m-u";
export var scrollable = "_m-e";
export var small = "_m-2";
export var success = "_m-q";
export var tight = "_m-m";
export var titleIcon = "_m-a";
export var warn = "_m-p";